import React from 'react';
import { PhoneFrame } from './components/PhoneFrame';
import { PlayerFrame } from './components/tracking/PlayerFrame';
import { TrackingTeaser } from './components/tracking/TrackingTeaser';
import { OriginalTeaser } from './components/OriginalTeaser';
type Edition = 'tracking' | 'original';
interface AppProps {
  /**
   * 'tracking' is the interactive-video cut: it opens on the clinical tracking
   * problem and lands the 12 minutes as a bonus. 'original' is the earlier,
   * product-led cut in the mobile story format.
   */
  edition?: Edition;
}
export function App({
  edition = 'tracking'
}: AppProps) {
  if (edition === 'original') {
    return <PhoneFrame data-id="element-0" data-mp="31ctf7r8y808n">
        <OriginalTeaser data-id="element-1" data-mp="2wk0av4he6tx3" />
      </PhoneFrame>;
  }
  return <PlayerFrame data-id="element-2" data-mp="2wip5j08ate3v">
      <TrackingTeaser data-id="element-3" data-mp="2wi5nzkmk8rqd" />
    </PlayerFrame>;
}